<template>
  <div class="home-view">
    <section class="site-hero home-hero" :style="heroStyle">
      <div class="site-hero__inner">
        <h1>以人才为核心，以技术为驱动</h1>
        <p class="desc desc-1">● 具备CMA、CNCA、CNAS权威认证的专业检验检测平台</p>
        <p class="desc">● 驱动行业革新的技术创新平台</p>
        <p class="desc">● 统筹生态共建的产业发展服务平台</p>
        <p class="desc">● 专业为企业打造产业数字化改革</p>
        <div class="hero-actions">
          <el-button type="primary" round @click="$router.push('/core-business')">业务板块</el-button>
          <el-button round @click="scrollTo('group')">集团简介</el-button>
        </div>
        <div class="hero-metrics">
          <article v-for="metric in heroMetrics" :key="metric.label" class="metric-card">
            <strong>{{ metric.value }}</strong>
            <span>{{ metric.label }}</span>
          </article>
        </div>
      </div>
    </section>
    <!-- 右边定位菜单 -->
    <nav class="side-nav" aria-label="Section navigation">
      <a v-for="item in locationMune" :key="item.label" :href="item.href">{{ item.label }}</a>
    </nav>
    <!-- 集团介绍 -->
    <section class="section group-section" id="group">
      <div class="intro-layout">
        <div class="intro-image"></div>
        <div>
          <div class="intro-copy intro-title">
            <h2 class="">集团介绍</h2>
            <div class="desc">
              <p>{{ groupIntro[0] }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 荣誉展示 -->
    <!-- <section id="qualification" class="section qualification-section alt">
      <div class="section-head">
        <div><h2>荣誉展示</h2></div>
      </div>
      <div class="qualification-track-shell">
        <div class="qualification-track">
          <article v-for="(item, index) in qualificationLoop" :key="`${item.title || 'certificate'}-${index}`" class="qualification-card panel-card">
            <div class="qualification-figure">
              <img :src="item.image" :alt="item.title">
            </div>
            <h3>{{ item.title }}</h3>
          </article>
        </div>
      </div>
    </section> -->

    <!-- 资质能力展示 -->
    <section id="qualification-ability" class="section qualification-section qualification-ability-section">
      <div class="section-head">
        <div><h2>资质能力展示</h2></div>
      </div>
      <div class="qualification-track-shell">
        <div class="qualification-track qualification-ability-track">
          <article v-for="(item, index) in qualificationAbilityLoop" :key="`${item.title}-${index}`" class="qualification-card qualification-ability-card panel-card">
            <div class="qualification-figure">
              <img :src="item.image" :alt="item.title">
            </div>
            <h3>{{ item.title }}</h3>
          </article>
        </div>
      </div>
    </section>
     
    <!-- 业务板块 -->
    <section id="capability" class="section capability-section alt">
      <div class="section-head">
        <h2>业务板块</h2>
      </div>
      <capability-grid :items="capabilityCards" :columns="3"/>
    </section>

    
    <!-- 联系我们 -->
    <section class="section contact-section" id="contact">
      <div class="contact-copy">
        <div class="contact-form-container">
          <div class="contact-form-head">
            <h3>在线留言</h3>
          </div>
          <el-form label-position="top" label-width="100px" :model="contactForm" class="contact-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业名称">
                  <el-input v-model="contactForm.enterprise" placeholder="输入企业名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务类型">
                  <el-select v-model="contactForm.businessType" placeholder="请选择业务类型" style="width: 100%;">
                    <el-option v-for="item in businessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名">
                  <el-input v-model="contactForm.name" placeholder="输入姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input v-model="contactForm.phone" placeholder="输入联系电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱">
                  <el-input v-model="contactForm.email" placeholder="输入邮箱"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="留言内容">
                  <el-input v-model="contactForm.message" type="textarea" rows="4" placeholder="请输入您的需求、业务方向或希望咨询的内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-button type="primary" round @click="submitMessage">提交留言</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <aside class="contact-panel">
        <dl>
          <div v-for="item in contactInfo" :key="item.label">
            <dt>{{ item.label }}</dt>
              <dd>{{ item.value }}</dd>
          </div>
        </dl>
      </aside>
    </section>
  </div>
</template>

<script>
import CapabilityGrid from "../components/CapabilityGrid.vue";
import { getSitePage, submitMessage } from "@/api/website";

export default {
  name: "HomeView",
  components: {
    CapabilityGrid
  },
  data() {
    return {
      capabilityCards: [],
      heroMetrics: [],
      groupIntro: [],
      qualificationCards: [],
      qualificationAbilityCards: [],
      qualificationHighlights: [],
      contactInfo: [],
      businessTypeList: [],
      bannerImage: "/assets/banner.png",
      locationMune: [
        { href: "#group", label: "集团简介" },
        // { href: "#qualification", label: "荣誉展示" },
        { href: "#qualification-ability", label: "资质能力" },
        { href: "#capability", label: "业务板块" },
        { href: "#contact", label: "联系我们" }
      ],
      contactForm: {
        enterprise: "",
        businessType: "",
        name: "",
        phone: "",
        email: "",
        message: ""
      },
    };
  },
  created() {
    this.loadPageData();
  },
  computed: {
    heroStyle() {
      return {
        backgroundImage: `linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%), url("${this.bannerImage}")`
      };
    },
    qualificationLoop() {
      return this.qualificationCards;
      //return this.qualificationCards.concat(this.qualificationCards);
    },
    qualificationAbilityLoop() {
      return this.qualificationAbilityCards.concat(this.qualificationAbilityCards);
    }
  },
  methods: {
    scrollTo(id) {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    loadPageData() {
      getSitePage("home").then((res) => {
        const data = res.data || {};
        const homeSettings = data.homeSettings || {};
        this.bannerImage = homeSettings.bannerImage || this.bannerImage;
        this.groupIntro = data.groupIntro || homeSettings.groupIntro || [];
        this.capabilityCards = data.capabilityCards || [];
        this.heroMetrics = data.heroMetrics || [];
        this.qualificationCards = data.qualificationCards || [];
        this.qualificationAbilityCards = data.qualificationAbilityCards || [];
        this.qualificationHighlights = data.qualificationHighlights || [];
        this.contactInfo = data.contactInfo || [];
        this.businessTypeList = data.businessTypeList || homeSettings.businessScope || [];
      });
    },
    submitMessage() {
      submitMessage(this.contactForm).then(() => {
        this.$message.success("留言已提交");
        this.contactForm = { enterprise: "", businessType: "", name: "", phone: "", email: "", message: "" };
      });
    },
  }
};
</script>

<style lang="less" scoped>
.home-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    url("/assets/banner.png") center top / cover no-repeat;
  }
.site-hero__inner {
  .desc {
    margin-top: 15px;
  }
  .desc-1 {
    margin-top: 30px;
  }
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 26px;
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 34px;
}

.metric-card {
  min-height: 126px;
  padding: 18px 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.metric-card strong {
  display: block;
  margin-bottom: 8px;
  font-size: 28px;
  color: var(--white);
}

.metric-card span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
}

.side-nav {
  position: fixed;
  top: 50%;
  right: 22px;
  z-index: 20;
  display: grid;
  gap: 10px;
  transform: translateY(-50%);
}

.side-nav a {
  min-width: 116px;
  padding: 12px 16px;
  border-radius: 999px;
  background: rgba(4, 26, 53, 0.84);
  color: rgba(255, 255, 255, 0.88);
  font-size: 13px;
  text-align: center;
  box-shadow: 0 14px 28px rgba(8, 43, 84, 0.18);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}
.section {
  padding: clamp(64px, 8vw, 112px) clamp(22px, 5vw, 76px);
  background: #f3f9ff;
}
.section-head {
  display: grid;
  grid-template-columns: minmax(0, .92fr) minmax(280px, .46fr);
  gap: 32px;
  align-items: end;
  margin-bottom: clamp(34px, 5vw, 64px);
}
.section h2 {
    margin: 0;
    font-size: clamp(34px, 5.2vw, 76px);
    font-weight: 950;
    line-height: 1;
    letter-spacing: 0;
}
.alt {
  background: linear-gradient(180deg, rgba(222, 241, 255, .96), rgba(236, 247, 255, .96));
}

.capability-section {
  overflow: hidden;
}

.group-section{
  padding: clamp(64px, 8vw, 112px) clamp(22px, 5vw, 76px);
  background: #f3f9ff;
  .intro-layout { 
    display: grid;
    grid-template-columns: minmax(0, 1.0fr) minmax(0, 1.0fr);
    gap: clamp(34px, 6vw, 86px);
    align-items: start;
    .intro-image {
      height: 100%;
      background-image: url("/assets/eut.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
      }
    }
    .intro-title {
      position: sticky;
      top: 112px;
      display: grid;
      gap: 24px;
      height: 100%;
      h2 {
        font-size: clamp(36px, 5.8vw, 84px);
      } 
    } 
    .intro-copy {
      display: grid;
      gap: 22px;
      color: #243b57;
      font-size: 18px;
      p{
        text-indent: 40px;
        margin: 0;
        line-height: 1.8;
      }
    }
  }
  .qualifications {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    margin-top: 48px;
    .qualification {
      min-height: 172px;
      padding: 26px;
      background: rgba(255, 255, 255, .82);
      border: 1px solid var(--line);
      border-radius: 8px;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .72);
      strong {
        display: block;
        margin-top: 22px;
        font-size: 26px;
        line-height: 1.2;
      }
      p {
        margin: 12px 0 0;
        color: var(--muted);
        font-size: 14px;
        line-height: 1.55;
      }
    }
  }
}

.qualification-section {
  .qualification-track-shell {
    overflow: hidden;
  }
  .qualification-track {
    display: flex;
    align-items: stretch;
    gap: 18px;
    width: max-content;
    animation: qualification-marquee 48s linear infinite;
    will-change: transform;
  }

  .qualification-track.is-static {
    width: 100%;
    animation: none;
  }

  .qualification-track-shell:hover .qualification-track {
    animation-play-state: paused;
  }
  .qualification-card {
    flex: 0 0 auto;
    width: min(280px, 74vw);
    padding: 18px;
    h3 {
      margin: 0;
      font-size: 18px;
    }
    .qualification-figure {
      display: grid;
      place-items: center;
      aspect-ratio: 1 / 0.72;
      margin-bottom: 14px;
      border-radius: 8px;
      background: #f4f9ff;
      overflow: hidden;
    }

    .qualification-figure img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.qualification-ability-section {
  padding-top: clamp(56px, 7vw, 96px);
  //background: linear-gradient(180deg, rgba(236, 247, 255, .96), rgba(243, 249, 255, .98));
  .qualification-ability-track {
    animation-duration: 40s;
  }

  .qualification-ability-card {
    width: min(320px, 78vw);

    .qualification-figure {
      aspect-ratio: 1 / 1.28;
    }
  }
}

.contact-section {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, .95fr);
  gap: clamp(30px, 6vw, 82px);
  align-items: start;
  .contact-copy {
    display: grid;
    gap: 24px;
    .contact-form-container {
      display: grid;
      gap: 16px;
      padding: clamp(24px, 4vw, 32px);
      background: rgba(255, 255, 255, .84);
      border: 1px solid var(--line);
      border-radius: 8px;
      .contact-form {
        /deep/ .el-form-item__label {
          color: var(--muted);
          font-size: 13px;
          font-weight: 900;
        }
      }
      .contact-form-head {
        display: grid;
        gap: 8px;
        h3{
          margin: 0;
          font-size: 24px;
          line-height: 1.15;
        }
      }
      .submit-btn {
        min-height: 46px;
        width: fit-content;
        padding: 0 22px;
        border: 0;
        border-radius: 999px;
        background: linear-gradient(135deg, #1d68c7, #0b4c9a);
        color: var(--white);
        font: inherit;
        font-size: 14px;
        font-weight: 900;
        cursor: pointer;
        transition: transform .2s ease, box-shadow .2s ease;
    }
    }
  }
  .contact-panel {
    padding: clamp(28px, 4vw, 46px);
    background: rgba(255, 255, 255, .82);
    border: 1px solid var(--line);
    border-radius: 8px;
    dl {
      display: grid;
      gap: 18px;
      margin: 0;
    }
    dt {
      color: var(--muted);
      font-size: 13px;
      font-weight: 900;
    }
    dd {
    margin: 6px 0 0;
    font-size: 18px;
    font-weight: 900;
  }
  }
}

@keyframes qualification-marquee {
  from { transform: translateX(0); }
  to { transform: translateX(calc(-50% - 9px)); }
}
@media (max-width: 1040px) {
  .hero-metrics{
    grid-template-columns: 1fr 1fr;
  }

  .section-head,
  .group-section .intro-layout,
  .contact-section {
    grid-template-columns: 1fr;
  }

  .group-section .intro-layout .intro-title {
    position: static;
  }

  .side-nav {
    top: auto;
    right: 18px;
    bottom: 18px;
    left: 18px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    transform: none;
  }
}

@media (max-width: 680px) {
  .home-hero {
    background-position: center top;
  }

  .section {
    padding: 48px 16px;
  }

  .section-head {
    gap: 14px;
    margin-bottom: 24px;
  }

  .capability-section {
    padding-left: 14px;
    padding-right: 14px;
  }

  .hero-actions {
    gap: 10px;
  }

  .hero-actions /deep/ .el-button {
    width: 100%;
    margin-left: 0;
  }

  .hero-metrics{
    grid-template-columns: 1fr;
  }

  .metric-card {
    min-height: 100px;
  }

  .metric-card strong {
    font-size: 24px;
  }

  .metric-card span {
    font-size: 12px;
  }

  .section h2,
  .group-section .intro-layout .intro-title h2 {
    font-size: 28px;
    line-height: 1.08;
  }

  .group-section .intro-layout .intro-copy {
    font-size: 14px;
  }

  .group-section .intro-layout .intro-copy p {
    text-indent: 2em;
  }

  .contact-section .contact-form-container {
    padding: 22px 16px;
  }

  .contact-section .contact-panel {
    padding: 24px 18px;
  }

  .contact-section .contact-form-head h3 {
    font-size: 20px;
  }

  .contact-section .contact-panel dd {
    font-size: 15px;
  }

  .contact-form /deep/ .el-col {
    width: 100%;
  }

  .side-nav {
    display: none;
  }
}
</style>
